import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t mt-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-gray-900">Help Center</a></li>
              <li><a href="#" className="hover:text-gray-900">Safety information</a></li>
              <li><a href="#" className="hover:text-gray-900">Cancellation options</a></li>
              <li><a href="#" className="hover:text-gray-900">Our COVID-19 Response</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Community</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-gray-900">GeoStays.org</a></li>
              <li><a href="#" className="hover:text-gray-900">Supporting people</a></li>
              <li><a href="#" className="hover:text-gray-900">Combating discrimination</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Hosting</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-gray-900">Try hosting</a></li>
              <li><a href="#" className="hover:text-gray-900">Responsible hosting</a></li>
              <li><a href="#" className="hover:text-gray-900">Community Center</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">About</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-gray-900">Newsroom</a></li>
              <li><a href="#" className="hover:text-gray-900">Learn about new features</a></li>
              <li><a href="#" className="hover:text-gray-900">Careers</a></li>
              <li><a href="#" className="hover:text-gray-900">Investors</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm text-gray-600">
            <div className="flex items-center space-x-4">
              <span>© 2025 GeoStays, Inc.</span>
              <a href="#" className="hover:text-gray-900">Privacy</a>
              <a href="#" className="hover:text-gray-900">Terms</a>
              <a href="#" className="hover:text-gray-900">Sitemap</a>
            </div>
            <div className="flex items-center space-x-4">
              <button className="hover:text-gray-900">English (IN)</button>
              <button className="hover:text-gray-900">₹ INR</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;